/*  MUI  */
import { Box, TableCell, TableFooter } from '@mui/material';

/*  React  */
import React from 'react';

/* Internal Components */
import { getHasFilters } from '../helpers';
import { ManagedTableClearFilterButton } from './ManagedTableClearFilterButton';
import { ManagedTablePagination } from './ManagedTablePagination';

export const ManagedTableFooter = ({
    apiTable,
    'data-trackid': dataTrackid,
    disabled,
    disableFirstAndLastPageButtons,
    filters,
    footer,
    isSearching,
    page,
    renderCount,
    rowCount,
    rowData,
    rowsApiPreload,
    rowsPerPage,
    setFilters,
    setPage,
    setRowsPerPage
}) => {
    const hasFilters = getHasFilters(filters);

    const onlyShowPagination = !footer && !hasFilters;

    return (
        <TableFooter data-testid="managedTableTableFooter">
            {/* I need a <tr> because <td> cannot appear as a child of <tfoot> */}
            {/* But I don't want to use the MUI Table row because it has a hover colour */}
            <tr>
                <TableCell colSpan="100%" sx={{ border: 0 }}>
                    <Box
                        display="flex"
                        className="hidePrint"
                        alignItems="center"
                        justifyContent={
                            onlyShowPagination ? 'flex-end' : 'space-between'
                        }
                        width="100%"
                    >
                        {footer}
                        {hasFilters && (
                            <ManagedTableClearFilterButton
                                data-trackid={dataTrackid}
                                disabledVal={disabled}
                                filters={filters}
                                setFilters={setFilters}
                            />
                        )}
                        <ManagedTablePagination
                            disableFirstAndLastPageButtons={
                                disableFirstAndLastPageButtons
                            }
                            apiTable={apiTable}
                            disabled={disabled}
                            page={page}
                            renderCount={renderCount}
                            rowCount={rowCount}
                            rowData={rowData}
                            rowsApiPreload={rowsApiPreload}
                            rowsPerPage={rowsPerPage}
                            isSearching={isSearching}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                    </Box>
                </TableCell>
            </tr>
        </TableFooter>
    );
};
